import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["handle"];

  connect() {
    this.pos1 = 0;
    this.pos2 = 0;
    this.pos3 = 0;
    this.pos4 = 0;

    this.elementDrag = this.elementDrag.bind(this);
    this.closeDragElement = this.closeDragElement.bind(this);

    const handle = this.hasHandleTarget ? this.handleTarget : this.element;
    handle.addEventListener("mousedown", this.dragMouseDown.bind(this));
  }

  dragMouseDown(event) {
    event.preventDefault();
    this.pos3 = event.clientX;
    this.pos4 = event.clientY;

    document.addEventListener("mousemove", this.elementDrag);
    document.addEventListener("mouseup", this.closeDragElement);
  }

  elementDrag(event) {
    event.preventDefault();
    this.pos1 = this.pos3 - event.clientX;
    this.pos2 = this.pos4 - event.clientY;
    this.pos3 = event.clientX;
    this.pos4 = event.clientY;

    this.element.style.top = `${this.element.offsetTop - this.pos2}px`;
    this.element.style.left = `${this.element.offsetLeft - this.pos1}px`;
  }

  closeDragElement() {
    document.removeEventListener("mousemove", this.elementDrag);
    document.removeEventListener("mouseup", this.closeDragElement);
  }
}
